import { createContext, useState } from 'react';
import { MarkerType, useEdgesState, useNodesState } from 'reactflow';
import { workflowConfigNodes } from 'config';
import { cloneDeep } from 'lodash';

export const WorkflowContext = createContext();

const WorkflowProvider = props => {
	const [initObj, setInitObj] = useState({});
	const [createObj, setCreateObj] = useState({});
	const [listingData, setListingData] = useState();
	const [dockerState, setDockerState] = useState('listing');
	const [flowInstance, setFlowInstance] = useState();
	const [nodes, setNodes, onNodesChange] = useNodesState([]);
	const [edges, setEdges, onEdgesChange] = useEdgesState([]);
	const [selectedNode, setSelectedNode] = useState();
	const [entryConditions, setEntryConditions] = useState([]);
	const [exitConditions, setExitConditions] = useState([]);
	const [componentState, setComponentState] = useState(null);
	const [nodeConfigureIndex, setNodeConfigureIndex] = useState(0);
	const [addWorkflowToggler, setAddWorkflowToggler] = useState(false);
	const [dedupError, setDedupError] = useState();
	const [templateList, setTemplateList] = useState([]);
	const [selectedCard, setSelectedCard] = useState(null);
	const [savePopupState, setSavePopupState] = useState(null);
	const [wfConditions, setWfConditions] = useState({});
	const [conditionType, setConditionType] = useState({});

	const reset = props => {
		props.createObj && resetConfigObj();
		setAddWorkflowToggler(false);
		setDockerState('listing');
		setDedupError(null);
		setNodeConfigureIndex(0);
		setSelectedCard(null);
		setSavePopupState(null);
		setSelectedNode(null);
		setComponentState(null);
		setNodeConfigureIndex(null);
		setAddWorkflowToggler(false);
		setDedupError(null);
		setSelectedCard(null);
		setSavePopupState(null);
		setWfConditions({});
		setConditionType({});
	};

	const resetConfigObj = () => {
		setCreateObj({ wf_name: '', wf_description: '', wf_conditions: {}, wf_nodes: [], wf_edges: [] });
		setNodes([]);
		setEdges([]);
	};

	const addNode = e => {
		setSelectedNode(e);
		setComponentState(() => {
			const config = cloneDeep(workflowConfigNodes);
			return config?.find(el => el?.key === e?.data?.type);
		});
	};

	const setNodeFlow = (node, index, sourceId, label) => {
		setNodes(prevState => {
			const nodeList = cloneDeep(prevState);
			let edgeList;
			if (nodeList[index]) {
				nodeList[index] = node;
			} else {
				nodeList.push(node);
			}
			sourceId &&
				setEdges(prevState => {
					edgeList = cloneDeep(prevState);
					edgeList = edgeList?.filter(el => el?.id !== `e${sourceId}-${index}`);
					edgeList = [...edgeList, { id: `${sourceId}->${index}`, label, source: `${sourceId}`, target: index?.toString(), type: 'smoothstep', markerEnd: { type: MarkerType.ArrowClosed } }];
					return edgeList;
				});
			setCreateObj(prevState => ({ ...prevState, wf_nodes: nodeList, wf_edges: edgeList }));
			setInitObj(prevState => ({ ...prevState, wf_nodes: nodeList, wf_edges: edgeList }));
			return nodeList;
		});
		setTimeout(() => flowInstance?.fitView(), 20);
	};

	const handleComponentClick = e => {
		setComponentState(() => {
			const config = cloneDeep(workflowConfigNodes)?.find(el => el?.key === e);
			return { ...config, currentStage: e };
		});
	};

	const handleDeleteNode = id => {
		let edgeList;
		setNodes(prevState => {
			let nodeList = cloneDeep(prevState);
			nodeList = nodeList?.filter(el => el?.id !== id);
			setEdges(prevState => {
				edgeList = cloneDeep(prevState);
				edgeList = edgeList?.filter(el => el?.target !== id);
				return edgeList;
			});
			setCreateObj(prevState => ({ ...prevState, wf_nodes: nodeList, wf_edges: edgeList }));
			return nodeList;
		});
	};

	return (
		<WorkflowContext.Provider
			value={{
				initObj,
				createObj,
				nodes,
				edges,
				flowInstance,
				componentState,
				selectedNode,
				listingData,
				addWorkflowToggler,
				dockerState,
				entryConditions,
				exitConditions,
				dedupError,
				nodeConfigureIndex,
				templateList,
				selectedCard,
				savePopupState,
				wfConditions,
				conditionType,
				setConditionType,
				setWfConditions,
				setSelectedCard,
				setSavePopupState,
				setTemplateList,
				setNodeConfigureIndex,
				setDedupError,
				setEntryConditions,
				setExitConditions,
				setDockerState,
				setAddWorkflowToggler,
				handleComponentClick,
				setComponentState,
				setEdges,
				onNodesChange,
				onEdgesChange,
				setNodes,
				setCreateObj,
				setInitObj,
				setFlowInstance,
				reset,
				setListingData,
				setSelectedNode,
				addNode,
				setNodeFlow,
				handleDeleteNode
			}}
		>
			{props.children}
		</WorkflowContext.Provider>
	);
};

export default WorkflowProvider;
